import axios from 'axios'
import { getToken, setToken, removeUserSession } from '../../utility/genricFunction'
import { refreshToken } from '../../store/builders/auth/auth.builders'
import { store } from '../../store/store'
// import { setUserToken } from '../../store/slice/auth/authenticationSlice'
import { toast } from 'react-toastify'

const apiClient = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_LIVE_URL,
})

apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token?.accessToken) {
      config.headers.Authorization = `Bearer ${token.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


let isRefreshing = false;
let refreshAndRetryQueue = [];

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const { response } = error;

    if (response?.status === 401) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          refreshAndRetryQueue.push({ resolve, reject, config: originalRequest });
        });
      }

      isRefreshing = true;

      try {
        const token = getToken();
        if (!token || !token.refreshToken) {
          throw new Error('No refresh token available');
        }

        const refreshTokenResponse = await refreshToken(token.refreshToken, store.dispatch);
        if (refreshTokenResponse.status !== 200) {
          throw new Error('Session expired!');
        }

        const newAccessToken = refreshTokenResponse?.data?.result?.accessToken;
        setToken(refreshTokenResponse.data.result);

        apiClient.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;

        refreshAndRetryQueue.forEach(({ resolve, config }) => {
          config.headers['Authorization'] = `Bearer ${newAccessToken}`;
          resolve(apiClient(config));
        });
        refreshAndRetryQueue = [];

        return apiClient(originalRequest);
      } catch (refreshError) {
        refreshAndRetryQueue.forEach(({ reject }) => reject(refreshError));
        refreshAndRetryQueue = [];

        if (refreshError.message === 'Session expired!') {
          removeUserSession(store.dispatch);
          toast.error('Session expired! Please log in again.', {
            className: 'custom-toast-error',
            progressStyle: { background: '#C53C43' },
          });
        }

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    } else {
      // If the error is not 401, don't clear the session; just reject the promise
      return Promise.reject(error);
    }
  }
);

export default apiClient;

